// extracted by mini-css-extract-plugin
export default {"TableView":"SalesTable_TableView__dErhM","Cell":"SalesTable_Cell__EQ5SO","Paper":"SalesTable_Paper__WLmdV"};